/**
 * Client-only debug flags for per-user subsystem toggles.
 * Only active when oad_debug=1 is present in URL.
 * Safe to call on server (returns all false).
 */
export interface OadDebugFlags {
  enabled: boolean;
  noAds: boolean;
  noMap: boolean;
  noPlaces: boolean;
  noHydrationScripts: boolean;
}

export function getDebugFlags(): OadDebugFlags {
  if (typeof window === 'undefined') {
    return {
      enabled: false,
      noAds: false,
      noMap: false,
      noPlaces: false,
      noHydrationScripts: false,
    };
  }
  const params = new URLSearchParams(window.location.search);
  const enabled = params.get('oad_debug') === '1';
  if (!enabled) {
    return {
      enabled: false,
      noAds: false,
      noMap: false,
      noPlaces: false,
      noHydrationScripts: false,
    };
  }
  return {
    enabled: true,
    noAds: params.get('oad_no_ads') === '1',
    noMap: params.get('oad_no_map') === '1',
    noPlaces: params.get('oad_no_places') === '1',
    noHydrationScripts: params.get('oad_no_hydration_scripts') === '1',
  };
}
